import { render, staticRenderFns } from "./toots.vue?vue&type=template&id=27bb4007"
import script from "./toots.vue?vue&type=script&lang=js"
export * from "./toots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports